import messages from "./messages";

export const features = [
    [{
        title: messages.title1,
        description: messages.description1,
        icon: "rename",
    },
    {
        title: messages.title2,
        description: messages.description2,
        icon: "performance",
    },
    {
        title: messages.title3,
        description: messages.description3,
        icon: "wifi",
    },],
    [
        {
            title: messages.title6,
            description: messages.description6,
            icon: "whiteboard",
        },
        {
            title: messages.title4,
            icon: "bell",
        },
        {
            title: messages.title5,
            description: messages.description5,
            icon: "homework",
        },
    ],
    [{
        title: messages.title7,
        description: messages.description7,
        icon: "duplicate",
    },
    {
        title: messages.title8,
        description: messages.description8,
        icon: "view",
    },]
]